export type TicketEventLocation =
  | string
  | {
      address?: string;
      city?: string;
      province?: string;
      country?: string;
      country_code?: string;
      latitude?: string | number | null;
      longitude?: string | number | null;
      code?: string;
      [key: string]: any;
    }
  | null;

export type TicketType = {
  id: string;
  name: string;
};

export type TicketOption = {
  id: string;
  price: number;
  multi_use: boolean;
  external_reference?: string;
  ticket_type?: TicketType;
};

export type TicketEventSeries = {
  id: string;
  name: string;
  external_reference?: string;
};

export type MerchantStoreInfo = {
  icon?: string;
};

export type CustomTicketType = {
  id: string;
  name: string;
  external_reference?: string;
};

export type TicketEventMerchant = {
  id: string;
  name: string;
  store_infos?: MerchantStoreInfo[];
};

export type TicketEvent = {
  id: string;
  status?: string;
  external_reference: string;
  code: string;
  colour?: string;
  name: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  ticket_sales_close_date?: string;
  facebook_page?: string;
  instagram_page?: string;
  location?: TicketEventLocation;
  approval_comments?: string[];
  approval_audit_trail?: string[];
  available_tickets?: number;
  sold_tickets?: number;
  merchant?: TicketEventMerchant;
  ticket_event_series?: TicketEventSeries;
  ticket_options?: TicketOption[];
  active_custom_ticket_types?: CustomTicketType[];
};

export const REVIEWABLE_STATUSES = ["pending_approval", "changes_requested"];

export const ALL_TICKET_EVENT_STATUSES = [
  "draft",
  "pending_approval",
  "active",
  "changes_requested",
  "cancelled",
  "completed",
];
